<self-pay-soe-change-of-address-pdf [selfPay]="selfPay" *ngIf="selfPay.selfPayType.selfPayTypeCode==='SOEA'"></self-pay-soe-change-of-address-pdf>